import { RouterConfigOptions } from "@angular/router";

/**
 * Configuração do Router do platform (`withRouterConfig` em `app.config.ts`).
 *
 * `canceledNavigationResolution: "computed"` — DEV-980: o detalhe em Atribuições tem `canDeactivate`
 * (runner da Avaliação aberto). Num Voltar do navegador/Android o histórico já recuou quando o guard
 * roda; com o padrão `"replace"`, recusar a saída regrava a URL atual por cima da entrada anterior, e
 * a tela de Atribuições some do histórico (o próximo Voltar pula para antes dela ou fecha o PWA). Com
 * `"computed"`, o Router volta para a entrada em que estava (`historyGo`) e o histórico fica intacto.
 */
export const PLATFORM_ROUTER_CONFIG: RouterConfigOptions = {
  canceledNavigationResolution: "computed"
};
